import React, { useCallback, useState } from 'react'
import { withRouter } from 'react-router'

function WrappedSearchBar({selected, term: propTerm, history}) {
	const [category, setCategory] = useState(selected)
	const [term, setTerm] = useState(propTerm)

	const handleTerm = useCallback((el) => setTerm(el.target.value), [])
	const handleCategory = useCallback((el) => setCategory(el.target.value), [])

	const submitForm = useCallback((el) => {
		el.preventDefault()
		let qs = `?q=${term}&category=${category}`
		let target = '/auckland-properties-for-sale-and-lease/search'

		switch (category) {
			case 'warehouses':
			case 'offices':
			case 'retail-show-rooms':
				target = `/auckland-property-vacancies-and-rentals/${category}`
				break
			case 'new-developments':
			case 'residential':
			case 'auckland-properties-for-sale':
				target = `/auckland-properties-for-sale/${category}`
				break
			case 'auckland-land-yards-for-lease-and-sale':
				target = '/auckland-land-yards-for-lease-and-sale'
				break
			default:
				target = '/auckland-properties-for-sale-and-lease/search'
				qs += '&category=all'
				break
		}

		history.push(target + qs)
	}, [category, term, history])

		return (
			<div className="search app-home-search app-results-search mdl-typography--text-center search-warehouse">
				<form
					action="/auckland-properties-for-sale-and-lease/search"
					className="form content-block mdl-grid search__box trans-back"
					onSubmit={submitForm}
				>
					<div className="form__select mdl-cell mdl-cell--2-col mdl-cell--8-col-tablet mdl-cell--4-col-phone">
						<div className="form__selectfield mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label dull-back">
							<i className="material-icons">arrow_drop_down</i>
							<select
								id="titleselect"
								name="category"
								value={category}
								onChange={handleCategory}
								className="mdl-selectfield__select"
							>
								<option value="All">All</option>

								<option value="warehouses">Warehouse</option>

								<option value="offices">Office</option>

								<option value="retail-show-rooms">Retail</option>

								<option value="new-developments">Developments</option>

								<option value="residential">Residential</option>

								<option value="auckland-properties-for-sale">
                  Properties for Sale
								</option>

								<option value="auckland-land-yards-for-lease-and-sale">
                  Land yards
								</option>
							</select>
						</div>
					</div>

					<div className="mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet mdl-cell--4-col-phone ">
						<div className="form__textfield mdl-textfield mdl-js-textfield">
							<input
								className="form__input mdl-textfield__input"
								name="q"
								type="text"
								onChange={handleTerm}
								id="sample1"
								value={term}
								placeholder="Search by location or keyword"
							/>
							<span className="bar"></span>
						</div>
					</div>

					<div className="mdl-cell mdl-cell--2-col mdl-cell--8-col-tablet mdl-cell--4-col-phone">
						<button className="button form__button mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect logo-font">
              Search <i className="material-icons">&#xE8B6;</i>
						</button>
					</div>
				</form>
			</div>
		)
}

const SearchBar = withRouter((props) => {
	const { ...rest } = props
	const qs = props.location.search.substr(1)
	let term = ''
	if (qs) {
		const queries = qs.split('&')
		let l, i

		for (i = 0, l = queries.length; i < l; i++) {
			let temp = queries[i].split('=')
			if (temp[0] === 'q') {
				term = decodeURIComponent(temp[1])
			}
		}
	}
	return <WrappedSearchBar term={term} {...rest} />
})
export default SearchBar
